import { SubmitKey } from '@/store/config'

export default {
  Error: {
    Unauthorized:
      "访问密码不正确或为空，请前往[登录](/#/auth)页输入正确的访问密码，或者在[设置](/#/settings)页填入你自己的 OpenAI API Key。",
  },
  Auth: {
    Title: "需要密码",
    Tips: "管理员开启了密码验证，请在下方填入访问码",
    Input: "在此处填写访问码",
    Confirm: "确认",
    Later: "稍后再说",
  },
  ChatItem: {
    ChatItemCount: (count: number) => `${count} 条对话`,
  },
  Form: {
    PleaseInput: "请输入",
    PleaseSelect: "请选择",
  },
  Chat: {
    SubTitle: (count: number) => `共 ${count} 条对话`,
    AppDown: "已下架",
    AppInfoTitle: "应用介绍",
    AppDownLine1: "应用已下架",
    AppDownLine2: "发布者重新上架即可恢复服务",
    AppConfigChange1: "应用配置变更，请",
    AppConfigChange2: "新开会话",
    AppConfigChange3: "使用",
    AppCloseDivider: "应用已下架，发布者重新上架即可恢复服务",
    GenerateTab1: "表单",
    GenerateTab2: "我的保存",
    TypeSession: "会话型",
    TypeGenerate: "生成型",
    OffLine: "未上架",
    Add: "添加",
    Remove: "移除",
    Generate: "生成",
    Save: "保存",
    SaveSuccess: "保存成功",
    DeleteSuccess: "删除成功",
    Empty: "暂无数据",
    Actions: {
      ChatList: "查看消息列表",
      CompressedHistory: "查看压缩后的历史 Prompt",
      Export: "导出聊天记录",
      Copy: "复制",
      Stop: "停止",
      Retry: "重新生成",
      Sound:  "语音朗读",
      SoundStop: "暂停朗读",
      SoundResume: "继续朗读",
      Pin: "固定",
      PinToastContent: "已将 2 条对话固定至预设提示词",
      PinToastAction: "查看",
      Delete: "删除",
      Edit: "编辑",
    },
    Commands: {
      new: "新建聊天",
      newm: "从面具新建聊天",
      next: "下一个聊天",
      prev: "上一个聊天",
      clear: "清除上下文",
      del: "删除聊天",
    },
    InputActions: {
      Stop: "停止响应",
      ToBottom: "滚到最新",
      Theme: {
        auto: "自动主题",
        light: "亮色模式",
        dark: "深色模式",
      },
      Prompt: "快捷提示",
      UserPrompt: "常用提示",
      Masks: "所有面具",
      Clear: "清除上下文",
      Settings: "对话设置",
      Reset: "重置",
    },
    Rename: "重命名会话名称",
    Typing: "正在输入…",
    Input: (submitKey: string) => {
      let inputHints = `${submitKey} 发送`;
      if (submitKey === String(SubmitKey.Enter)) {
        inputHints += "，Shift + Enter换行";
      }
      return inputHints + "，/快捷提示，#常用提示";
    },
    WebappInput: () => '请在此输入您的提问',
    BuildInput: (submitKey: string) => {
      let inputHints = `${submitKey} 发送`;
      if (submitKey === String(SubmitKey.Enter)) {
        inputHints += "，Shift + Enter换行";
      }
      return inputHints;
    },
    Send: "发送",
    Loading: "发送中",
    Sending: "生成中",
    Stop: "停止",
    Config: {
      Reset: "清除记忆",
      SaveAs: "存为面具",
    },
    SuggestTitle: "你可以继续问我：",
  },
  Export: {
    Title: "分享聊天记录",
    AppTitle: "分享应用",
    Copy: "复制",
    Download: "下载",
    Share: "微信分享",
    MessageFromYou: "来自你的消息",
    MessageFromChatGPT: "来自 绿巢环境GPT 的消息",
    Format: {
      Title: "导出格式",
      SubTitle: "可以导出 Markdown 文本或者 PNG 图片",
    },
    IncludeContext: {
      Title: "包含面具上下文",
      SubTitle: "是否在消息中展示面具上下文",
    },
    Steps: {
      Select: "选取",
      Preview: "预览",
    },
  },
  Select: {
    Search: "搜索消息",
    All: "选取全部",
    Latest: "最近4条",
    Clear: "清除选中",
  },
  Memory: {
    Title: "历史摘要",
    EmptyContent: "对话内容过短，无需总结",
    Send: "自动压缩聊天记录并作为上下文发送",
    Copy: "复制摘要",
    Reset: "[unused]",
    ResetConfirm: "确认清空历史摘要？",
  },
  Home: {
    NewChat: "新增会话",
    NewApp: "构建应用",
    AppMarket: "应用市场",
    AppManage: "应用管理",
    Dataset: "数据集",
    Interface: "API接口",
    DeleteChat: "确认删除选中的对话？",
    DeleteToast: "已删除会话",
    Revert: "撤销",
    RenameChat: "修改成功",
    Empty: {
      ChatTit: "您好，我是绿巢环境GPT",
      ChatSubTit:
        "为您提供环境与低碳的专业知识、政策法规、规划设计、管理咨询、解决方案、办公文件等服务。",
      PolicySubTit:
        "您可以更方便的通过询问具体政策名称来获取此政策信息，也可以通过多维度筛选获得更深层的数据分析服务",
      BidSubTit:
        "您可以更方便的通过询问具体招标名称来获取此项目信息，也可以通过多维度筛选获得更深层的数据分析服务",
    },
  },
  Settings: {
    Title: "设置",
    SubTitle: "所有设置选项",

    Danger: {
      Reset: {
        Title: "重置所有设置",
        SubTitle: "重置所有设置项回默认值",
        Action: "立即重置",
        Confirm: "确认重置所有设置？",
      },
      Clear: {
        Title: "清除所有数据",
        SubTitle: "清除所有聊天、设置数据",
        Action: "立即清除",
        Confirm: "确认清除所有聊天、设置数据？",
      },
    },
    Lang: {
      Name: "Language", // ATTENTION: if you wanna add a new translation, please do not translate this value, leave it as `Language`
      All: "所有语言",
    },
    Avatar: "头像",
    FontSize: {
      Title: "字体大小",
      SubTitle: "聊天内容的字体大小",
    },

    InputTemplate: {
      Title: "用户输入预处理",
      SubTitle: "用户最新的一条消息会填充到此模板",
    },

    Update: {
      Version: (x: string) => `当前版本：${x}`,
      IsLatest: "已是最新版本",
      CheckUpdate: "检查更新",
      IsChecking: "正在检查更新...",
      FoundUpdate: (x: string) => `发现新版本：${x}`,
      GoToUpdate: "前往更新",
    },
    SendKey: "发送键",
    Theme: "主题",
    TightBorder: "无边框模式",
    SendPreviewBubble: {
      Title: "预览气泡",
      SubTitle: "在预览气泡中预览 Markdown 内容",
    },
    Mask: {
      Title: "面具启动页",
      SubTitle: "新建聊天时，展示面具启动页",
    },
    Prompt: {
      Disable: {
        Title: "禁用提示词自动补全",
        SubTitle: "在输入框开头输入 / 即可触发自动补全",
      },
      List: "自定义提示词列表",
      ListCount: (builtin: number, custom: number) =>
        `内置 ${builtin} 条，用户定义 ${custom} 条`,
      Edit: "编辑",
      Modal: {
        Title: "提示词列表",
        Add: "新建",
        Search: "搜索提示词",
      },
      EditModal: {
        Title: "编辑提示词",
      },
    },
    HistoryCount: {
      Title: "附带历史消息数",
      SubTitle: "每次请求携带的历史消息数",
    },
    CompressThreshold: {
      Title: "历史消息长度压缩阈值",
      SubTitle: "当未压缩的历史消息超过该值时，将进行压缩",
    },
    Token: {
      Title: "API Key",
      SubTitle: "使用自己的 Key 可绕过密码访问限制",
      Placeholder: "OpenAI API Key",
    },

    Usage: {
      Title: "余额查询",
      SubTitle(used: any, total: any) {
        return `本月已使用 $${used}，订阅总额 $${total}`;
      },
      IsChecking: "正在检查…",
      Check: "重新检查",
      NoAccess: "输入 API Key 或访问密码查看余额",
    },
    AccessCode: {
      Title: "访问密码",
      SubTitle: "管理员已开启加密访问",
      Placeholder: "请输入访问密码",
    },
    Endpoint: {
      Title: "接口地址",
      SubTitle: "除默认地址外，必须包含 http(s)://",
    },
    Model: "模型 (model)",
    Temperature: {
      Title: "随机性 (temperature)",
      SubTitle: "值越大，回复越随机",
    },
    TopP: {
      Title: "核采样 (top_p)",
      SubTitle: "与随机性类似，但不要和随机性一起更改",
    },
    MaxTokens: {
      Title: "单次回复限制 (max_tokens)",
      SubTitle: "单次交互所用的最大 Token 数",
    },
    PresencePenalty: {
      Title: "话题新鲜度 (presence_penalty)",
      SubTitle: "值越大，越有可能扩展到新话题",
    },
    FrequencyPenalty: {
      Title: "频率惩罚度 (frequency_penalty)",
      SubTitle: "值越大，越有可能降低重复字词",
    },
  },
  Store: {
    DefaultTopic: "会话",
    BotHello: "有什么可以帮你的吗",
    Error: "出错了，稍后重试吧",
    Prompt: {
      History: (content: string) => "这是历史聊天总结作为前情提要：" + content,
      Topic:
        "使用四到五个字直接返回这句话的简要主题，不要解释、不要标点、不要语气词、不要多余文本，如果没有主题，请直接返回“闲聊”",
      Summarize:
        "简要总结一下对话内容，用作后续的上下文提示 prompt，控制在 200 字以内",
    },
  },
  Copy: {
    Success: "复制成功",
    Failed: "复制失败，请赋予剪切板权限",
  },
  Context: {
    Toast: (x: any) => `包含 ${x} 条预设提示词`,
    Edit: "当前对话设置",
    Add: "新增预设对话",
    Clear: "上下文已清除",
    Revert: "恢复上下文",
  },
  Plugin: {
    Name: "idea广场",
  },
  Mask: {
    Name: "面具",
    Page: {
      Title: "预设角色面具",
      SubTitle: (count: number) => `${count} 个预设角色定义`,
      Search: "搜索角色面具",
      Create: "新建",
    },
    Item: {
      Info: (count: number) => `包含 ${count} 条预设对话`,
      Chat: "对话",
      View: "查看",
      Edit: "编辑",
      Delete: "删除",
      DeleteConfirm: "确认删除？",
    },
    EditModal: {
      Title: (readonly: boolean) =>
        `编辑预设面具 ${readonly ? "（只读）" : ""}`,
      Download: "下载预设",
      Clone: "克隆预设",
    },
    Config: {
      Avatar: "角色头像",
      Name: "角色名称",
      Sync: {
        Title: "使用全局设置",
        SubTitle: "当前对话是否使用全局模型设置",
        Confirm: "当前对话的自定义设置将会被自动覆盖，确认启用全局设置？",
      },
      HideContext: {
        Title: "隐藏预设对话",
        SubTitle: "隐藏后预设对话不会出现在聊天界面",
      },
    },
  },
  NewChat: {
    Return: "返回",
    Skip: "直接开始",
    NotShow: "不再展示",
    ConfirmNoShow: "确认禁用？禁用后可以随时在设置中重新启用。",
    Title: "挑选一个面具",
    SubTitle: "现在开始，与面具背后的灵魂思维碰撞",
    More: "查看全部",
  },

  UI: {
    Confirm: "确认",
    Cancel: "取消",
    Close: "关闭",
    Create: "新建",
    Edit: "编辑",
    Submit: "提交",
  },
  Exporter: {
    Model: "模型",
    Messages: "消息",
    Topic: "主题",
    Time: "时间",
  },
  Dataset: {
    Dataset: "知识库",
    CreateDataset: "创建知识库",
    FilePreview: "文件预览",
  },
  API: {
    keys: {
      charge: "充值",
      quota: "额度(元)",
      addKey: "新增API Key",
      tips: "列表内是你的全部API Key，请不要与他人共享你的API Key，避免将其暴露在浏览器和其他客户端代码中",
      remainQuota: "剩余额度",
      exchange: "兑换",
      getExchangeCode: "获取兑换码",
      editTips:
        "注意：API Key的额度仅限于限制API Key本身的最大额度使用量，实际的使用受到账户的剩余额度限制。",
    },
    log: {
      detail: "使用明细",
      total: "总消费额度",
      preview: "点击查看",
    },
  },
}